module.exports = __webpack_public_path__ + "static/blue-vector-569fc1b3f82de959e64c083c959ce3a2.jpg";